import { useNavigate } from "react-router-dom";
import { LockKey, ArrowRight } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useSub, TIER_ORDER } from "@/context/SubscriptionContext";
import { isNativeApp } from "@/lib/native";

const COPY = {
  pro: { label: "Pro", blurb: "Market Scanner, probabilistic forecasts, the model scorecard and price/score alerts." },
  elite: { label: "Elite", blurb: "Backtesting, the custom strategy builder, portfolio backtests, strategy alerts and unlimited AI." },
};

export function Paywall({ need = "pro", compact = false }) {
  const nav = useNavigate();
  const c = COPY[need] || COPY.pro;
  return (
    <div data-testid={`paywall-${need}`}
      className={`border border-volt/30 bg-volt/[0.04] rounded-sm text-center flex flex-col items-center ${compact ? "p-6" : "p-12 mt-6"}`}>
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-volt/15 border border-volt/30">
        <LockKey size={24} className="text-volt" />
      </div>
      <div className="mt-4 label-xs text-volt">{c.label} feature</div>
      <h3 className="mt-1 font-heading text-xl font-semibold">Unlock with MarketPilot {c.label}</h3>
      <p className="mt-2 max-w-md text-sm text-muted-foreground">{c.blurb}</p>
      {isNativeApp() ? (
        <p className="mt-5 max-w-md text-sm text-muted-foreground">This feature is not included in your current plan.</p>
      ) : (<>
      <Button data-testid="paywall-upgrade-btn" onClick={() => nav("/pricing")}
        className="mt-5 bg-volt hover:bg-volt/90 text-white rounded-sm gap-2">
        View Plans <ArrowRight size={16} />
      </Button>
      <p className="mt-3 mono text-[11px] text-muted-foreground">7-day free trial · cancel anytime</p>
      </>)}
    </div>
  );
}

export function Gate({ need = "pro", children, compact = false }) {
  const { effectiveTier, loading } = useSub();
  if (loading) return null;
  if (TIER_ORDER[effectiveTier] >= TIER_ORDER[need]) return children;
  return <Paywall need={need} compact={compact} />;
}
